
<h1 mat-dialog-title >{{ opMode === opModes.Create ? ("manage-user" | translate) : ("edit" | translate) }}</h1>

<div mat-dialog-content>
  <mat-form-field *ngIf="opMode === opModes.Create">
    <mat-label>{{ "mail" | translate }}</mat-label>
    <input type="email" matInput [(ngModel)]="model.email" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "name" | translate }}</mat-label>
    <input matInput [(ngModel)]="model.firstname" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "surname" | translate }}</mat-label>
    <input matInput [(ngModel)]="model.lastname" />
  </mat-form-field>

  <mat-form-field *ngIf="opMode === opModes.Create">
    <mat-label>{{ "password" | translate }}</mat-label>
    <input matInput type="password" [(ngModel)]="model.password" />
  </mat-form-field>

  <mat-form-field>
    <mat-label>{{ "user-type" | translate }}</mat-label>
    <mat-select [(ngModel)]="model.type">
      <mat-option
        *ngFor="let type of userTypesEnumValues"
        [value]="userTypes[type]"
      >
        {{ type }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions align="end">
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="true"
    (click)="onConfirm()"
    cdkFocusInitial
  >
    {{ "confirm" | translate }}
  </button>

  <button mat-raised-button [mat-dialog-close]="false">
    {{ "cancel" | translate }}
  </button>
</div>
